export const HeaderLinks = [
  {
    label: "The Nature Conservancy",
    url: "https://nature.org/marine/",
    children: [],
  },
  {
    label: "Legal Disclosure",
    url: "https://coastalresilience.org/terms-of-use/",
    children: [],
  },
  {
    label: "Other Regions",
    url: "",
    children: [
      {
        label: "California",
        url: "https://maps.coastalresilience.org/california",
      },
      {
        label: "Caribbean",
        url: "https://storymaps.arcgis.com/stories/9a25aad469d440048c9df963131b0c7e",
      },
      {
        label: "Connecticut",
        url: "https://maps.coastalresilience.org/connecticut",
      },
      {
        label: "The Dominican Republic, Jamaica, and Grenada",
        url: "https://resilientislands.tnc.org/",
      },
      {
        label: "Global",
        url: "https://maps.coastalresilience.org",
      },
      {
        label: "Gulf of Mexico",
        url: "https://maps.coastalresilience.org/gulfmex",
      },
      {
        label: "Grenada, St. Vincent & the Grenadines",
        url: "https://maps.coastalresilience.org/gsvg",
      },
      {
        label: "MesoAmerican Reef",
        url: "https://maps.coastalresilience.org/mar",
      },
      {
        label: "New Jersey",
        url: "https://maps.coastalresilience.org/newjersey",
      },
      {
        label: "Southeast Florida",
        url: "https://maps.coastalresilience.org/seflorida",
      },
      {
        label: "United States",
        url: "https://maps.coastalresilience.org/unitedstates/",
      },
      {
        label: "U.S. Virgin Islands",
        url: "https://maps.coastalresilience.org/usvi",
      },
      {
        label: "Washington",
        url: "https://maps.coastalresilience.org/pugetsound",
      },
    ],
  },
];
